<template>
    <ValidationObserver ref="updatePreferenceForm" v-slot="{ invalid }">
        <b-row class="mt-5">
            <b-col cols="12" md="6">
                <ValidationProvider name="faculty_code" rules="required" v-slot="{ valid, errors }">
                    <b-form-group :label="$t('faculty')">
                        <faculty-selectbox v-model="form.faculty_code" :validate-error="errors[0]"></faculty-selectbox>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" md="6">
                <ValidationProvider name="department_code" rules="required" v-slot="{ valid, errors }">
                    <b-form-group :label="$t('department')">
                        <department-selectbox v-model="form.department_code"
                                              :faculty_code="form.faculty_code" :validate-error="errors[0]" />
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" md="6">
                <ValidationProvider name="program_code" rules="required" v-slot="{ valid, errors }">
                    <b-form-group :label="$t('program')">
                        <program-selectbox v-model="form.program_code" :faculty_code="form.faculty_code"
                                           :department_code="form.department_code" :validate-error="errors[0]" />
                    </b-form-group>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" md="6">
                <ValidationProvider name="rank" rules="required" v-slot="{errors}">
                    <b-form-group :label="$t('rank')">
                        <ParameterSelectbox code="preference_order_application_module" v-model="form.rank" :validate-error="errors[0]"/>
                    </b-form-group>
                </ValidationProvider>
            </b-col>

            <b-col cols="12" class="d-flex justify-content-center align-items-center mt-1">
                <ProcessingButton :label="$t('save')" @click="updatePreferences" :processing="loading"  :disabled="invalid">

                </ProcessingButton>
            </b-col>

        </b-row>
    </ValidationObserver>
</template>
<script>
import ProcessingButton from "@/components/elements/ProcessingButton.vue";
import PromontionApplicationServices from "@/services/PromontionApplicationServices";

export default {
    name: "UpdatePreferences",
    components: {ProcessingButton},
    props:{
        formId:{
            type:Number,
            required:true
        },
        promotionalProcessId:{
            type:Number,
            required:true
        }
    },
    data(){
        return {
            loading:false,
            form:{
                faculty_code:null,
                department_code:null,
                program_code:null,
                rank:null
            }
        }
    },
    created() {
      this.getPreferenceDetail()
    },
    methods:{
        async getPreferenceDetail(){
           try {
               const res =await PromontionApplicationServices.showPreference(this.formId)
               const data =res.data.data
               this.form={
                        faculty_code:data.faculty_code,
                           department_code:data.department_code,
                           program_code:data.program_code,
                       rank:data.rank
               }
           }catch (err){
               this.showErrors(err,this.$refs.preferenceInformation)
           }
        },
        async updatePreferences(){
            const isValid=await this.$refs.updatePreferenceForm.validate();
            if (!isValid)return
            try {
                this.form.promotional_process_id=this.promotionalProcessId
                const res =await PromontionApplicationServices.updatePreference(this.formId,this.form)
                 this.toast(res.data)
                this.$emit('updateSuccess')
            }catch (e) {
                this.showErrors(e,this.$refs.updatePreferenceForm)
            }

        }
    }
}
</script>

<style scoped>

</style>
